import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { FormsUtilsService } from '../../../../../core';

import * as _ from 'lodash';
import { LeadContato } from '../lead-contato';
import { PessoaContatoTipo, PessoaContatoTipoSortPipe, outrosContatosTipos, isContatoTipoPrimario, isContatoTipoPrincipal } from '../../../../pessoa/contato';

@Component({
    selector: 'sgt-lead-contato-form',
    templateUrl: './lead-contato-form.component.html',
    providers: [
        PessoaContatoTipoSortPipe
    ]
})
export class LeadContatoFormComponent implements OnInit {
    entity: LeadContato;
    editMode: boolean;

    /** Se o form deve ser exibido em tamanho pequeno */
    @Input() isMini = false;

    @ViewChild('form') form: NgForm;
    @ViewChild('contatoTipoSelect') contatoTipoSelect: ElementRef;
    @ViewChild('contatoNomeInput') contatoNomeInput: ElementRef;

    tipos: PessoaContatoTipo[];

    constructor(private pessoaContatoTipoSortPipe: PessoaContatoTipoSortPipe,
                private formsUtilsService: FormsUtilsService) { }

    ngOnInit(): void {
        this.tipos = this.pessoaContatoTipoSortPipe.transform(outrosContatosTipos);
    }

    /** Verifica se o tipo do contato é um dos contatos primarios */
    isContatoTipoPrimario() {
        return isContatoTipoPrimario(this.entity.tipo);
    }

    /** Verfica se o tipo de contato é Principal */
    isContatoTipoPrincipal() {
        return isContatoTipoPrincipal(this.entity.tipo);
    }

    insert(tipo: number = null) {
        this.editMode = false;
        this.entity = new LeadContato(tipo);
        setTimeout(() => this.setFocus(), 0);
    }

    edit(entity: LeadContato) {
        this.editMode = true;
        this.entity = _.cloneDeep(entity);
        setTimeout(() => this.setFocus(), 0);
    }

    isValid() {
        this.formsUtilsService.makeAllFieldsDirty(this.form);
        return this.form.valid;
    }

    /** Seta o foco no input do nome do contato */
    setFocus() {
        // Se estiver inserindo e não possuir um tipo setado por padrão, seta foco no select do tipo
        if (!this.editMode && !this.entity.tipo) {
            jQuery(this.contatoTipoSelect?.nativeElement).trigger('focus');
            return;
        }

        // Se não, seta o foco no input do nome
        jQuery(this.contatoNomeInput?.nativeElement).trigger('focus');
    }
}
